import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { Badge } from '@/components';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

import { TypeBadgeFields } from '@/core/generated-types';

export interface GenNavTileProps {
  title: string;
  subTitle?: string | undefined;
  description?: string | undefined;
  titleDecorator?: ReactNode;
  children?: ReactNode;
  badge?: TypeBadgeFields | undefined;
  classes?: string | undefined;
  titleClasses?: string | undefined;
}

const GenNavTile: FC<GenNavTileProps> = ({
  title,
  subTitle,
  titleDecorator,
  description,
  badge,
  children,
  classes,
  titleClasses,
}) => (
  <div
    data-testid="tile"
    className={classNames('rounded-md p-6 shadow-md lg:p-8', classes)}
  >
    {badge && (
      <div className="relative mb-3">
        <Badge {...badge} />
      </div>
    )}

    <div
      data-testid={`section-${title}`}
      className="mb-6 border-b border-charcoal-opacity-20"
    >
      <div className="align-center flex items-baseline justify-between gap-4">
        <Heading
          tag={HeadingTag.H2}
          size={titleClasses ? '' : HeadingSize.H2}
          text={title}
          align="left"
          classes={classNames('mb-6', titleClasses)}
        />

        {titleDecorator}
      </div>

      {subTitle && (
        <p
          data-testid={`subheader-${title}`}
          className="mb-4 text-left leading-6"
        >
          {subTitle}
        </p>
      )}
    </div>

    {description && (
      <p
        data-testid={`description-${title}`}
        className="mb-4 text-left leading-6"
      >
        {description}
      </p>
    )}

    {children}
  </div>
);

export default React.memo(GenNavTile);
